import {
  Component,
  Inject,
  Input,
  OnInit,
  Optional,
  ViewContainerRef,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  DIALOG_DATA,
  getFormattedForm,
  getInstanceRegion,
  noWhitespaceValidator,
} from '../../../../global.variable';
import { ClientsService } from '../../../pages/pages/clients/clients.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { ToasterService } from '../../services/toaster.service';
import { AddEditClientComponent } from '../add-edit-client/add-edit-client.component';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'gtapp-add-edit-site',
  templateUrl: './add-edit-site.component.html',
  styleUrl: './add-edit-site.component.scss',
  standalone: false,
})
export class AddEditSiteComponent implements OnInit {
  @Input() detailData: any;

  @Input() editSite: any;

  // edit site name/address toggle
  @Input() editSiteName: boolean = true;

  siteForm: UntypedFormGroup = new UntypedFormGroup({
    addressLookup: new UntypedFormControl(''),
    company: new UntypedFormControl(null, Validators.required),
    company_name: new UntypedFormControl(null, [
      Validators.required,
      noWhitespaceValidator(),
    ]),
    address1: new UntypedFormControl(''),
    address2: new UntypedFormControl('', [Validators.required]),
    address3: new UntypedFormControl(''),
    city_name: new UntypedFormControl('', [Validators.required]),
    postcode: new UntypedFormControl(''),
    longitude: new UntypedFormControl('', [Validators.required]),
    latitude: new UntypedFormControl('', [Validators.required]),
    country_name: new UntypedFormControl(getInstanceRegion(), [
      Validators.required,
    ]),
    state_code: new UntypedFormControl('', [Validators.required]),
    state_name: new UntypedFormControl('', [Validators.required]),
    auto_send_reports: new UntypedFormControl(false),
  });

  clientDataList: any;

  initialDataList: any = {};

  addSiteFormData: any = {
    client: {
      name: 'Client',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
  };

  siteExistsCheckData: any = {};

  constructor(
    @Optional() protected dialogRef: DialogRef,
    private clientService: ClientsService,
    private spinnerService: LoadingSpinnerService,
    private dialogService: ModalDialogueService,
    @Inject(DIALOG_DATA) public dialogueData: any,
    private toasterService: ToasterService,
    private viewContainerRef: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    if (this.dialogueData) {
      this.detailData = this.dialogueData?.detailData;
      this.editSite = this.dialogueData?.editSite;
      this.editSiteName = this.dialogueData?.editSiteName;
      if (this.editSiteName) this.shiftFocus('siteInputField');
    }

    this.onClientSearch('');
    this.formatSiteData();
    // this.appService.initializeBootstrapTooltips();
  }

  editField(field: string) {
    if (field == 'client') {
      this.addSiteFormData.client = {
        name: 'Client',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.shiftFocus('clientId');
    } else if (field == 'site') {
      this.siteForm.controls['company_name'].setValue(null);
      this.shiftFocus('siteInputField');
    }

    this.updateInitialDataList(field);
  }
  updateInitialDataList(field: any) {
    setTimeout(() => {
      if (field === 'client') {
        this.clientDataList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      }
    }, 200);
  }

  formatSiteData() {
    this.siteForm.patchValue(this.detailData);
    this.siteForm.controls['address1'].setValue(
      this.detailData?.address?.address1,
    );
    this.siteForm.controls['address2'].setValue(
      this.detailData?.address?.address2,
    );
    this.siteForm.controls['address3'].setValue(
      this.detailData?.address?.address3,
    );
    this.siteForm.controls['city_name'].setValue(
      this.detailData?.address?.city_name,
    );
    this.siteForm.controls['country_name'].setValue(
      this.detailData?.address?.country_name,
    );
    this.siteForm.controls['postcode'].setValue(
      this.detailData?.address?.postcode,
    );
    this.siteForm.controls['state_code'].setValue(
      this.detailData?.address?.state_code,
    );
    this.siteForm.controls['state_name'].setValue(
      this.detailData?.address?.state_name ||
        this.detailData?.address?.state_code,
    );
    this.siteForm.controls['latitude'].setValue(
      this.detailData?.address?.latitude,
    );
    this.siteForm.controls['longitude'].setValue(
      this.detailData?.address?.longitude,
    );
    this.siteForm.controls['company_name'].enable();

    if (this.detailData?.company) {
      // case where site is being created from the client page or prime contractor list
      this.onClientSelect({
        id: this.detailData?.company,
        company_name: this.detailData?.clientName,
        primeContractor: this.detailData?.primeContractor,
      });
      this.addSiteFormData.client.tempValue = this.detailData?.clientName;
    }
    if (this.siteForm.value?.company_name) {
      // site name has been passed from the parent for site creation

      this.shiftFocus('addressLookup');
    } else {
      this.shiftFocus('siteInputField');
    }
  }
  onCloseDialogue(data: any = 'close') {
    this.dialogRef.close(data);
  }
  addDuplicateSite() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Create Duplicate Site',
        message: `This site already exists under ${this.addSiteFormData?.client?.value}. Ignore and create a duplicate site with the same name?`,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.updateData();
      }
    });
  }

  updateData() {
    this.spinnerService.show();
    if (this.siteForm.valid) {
      const siteData = this.siteForm.getRawValue();

      getFormattedForm(this.siteForm, ['company_name']);

      var requestData = { data: siteData };

      if (this.detailData?.id) {
        this.spinnerService.show();
        this.clientService
          .updateSiteById(requestData, this.detailData?.id)
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });

              this.onCloseDialogue(response['data']);
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
            this.spinnerService.hide();
          });
      } else {
        this.spinnerService.show();

        this.clientService
          .addSiteInClient(requestData)
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });

              this.onCloseDialogue(response['data']);
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
            this.spinnerService.hide();
          });
      }
    } else {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Please fil the required fields',
      });
      this.spinnerService.hide();
    }
  }

  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    });
  }

  onClientSearch(event: any) {
    this.addSiteFormData.client.tempValue = event ? event.target.value : '';
    this.clientService
      .searchClients(this.addSiteFormData.client.tempValue)
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.clientDataList = res['data'];
          if (!event) {
            this.initialDataList.client = JSON.parse(JSON.stringify(res?.data));
          }
        }
      });
  }
  onClientSelect(data: any) {
    if (data?.key === 0) {
      this.openAddCustomerForm();
    }
    if (data?.id) {
      this.siteForm.controls['company'].setValue(data?.id);
      this.addSiteFormData.client.value = data?.company_name;
      this.addSiteFormData.client.data = data;
      this.checkSiteExists();
    }
  }
  openAddCustomerForm() {
    const dialogref = this.dialogService.open(AddEditClientComponent, {
      data: {
        companyData: {
          company_name: this.addSiteFormData.client.tempValue,
          address: this.siteForm?.value,
        },
      },
    });

    dialogref.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        this.onClientSelect(value?.data);
      }
    });
  }
  onAddressSelect() {
    this.addSiteFormData.client.tempValue = this.siteForm.value?.company_name;
    this.checkSiteExists();
  }
  checkSiteExists() {
    if (this.detailData?.id) return;
    if (!this.siteForm.valid) return;
    this.spinnerService.show('Checking');
    this.clientService
      .getSiteList({
        site_name: this.siteForm.value?.company_name,
        exists_check: 1,
        site_data: JSON.stringify(this.siteForm.value),
      })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.siteExistsCheckData = JSON.parse(
            JSON.stringify(response?.data || {}),
          );
        }
        this.spinnerService.hide();
      });
  }
  confirmAndUpdateSite(template: any) {
    const dialogref = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  addUpdateSite(update = false) {
    if (update) {
      this.detailData = this.detailData || {};
      this.detailData.id = this.siteExistsCheckData?.site_address_data?.id;
    }
    this.updateData();
  }
}
